







































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Load } from '@/domains/system';
import { Record } from '@/domains/work';

@Component({
  name: 'PaymentUserTable',
  components: {
  },
})
export default class PaymentUserTable extends Vue {
  /** bus */
  @Prop()
  private bus: Vue;

  /** 数据列表 */
  private datas: Record[] = [];

  private mounted() {
    this.bus.$on('payment-user-table', (datas: Record[]) => { this.datas = datas; });
  }
}
